import { useCallback } from 'react';
import { ExtendedWarrantyOption } from '../../types';
import { getDurationLabel } from '../../handlers/labelHandler';

type ExtendedWarrantyDurationProps = {
  readOnly: boolean;
  options: ExtendedWarrantyOption[];
  selectedOption: number;
  onChange: (newDuration: number) => void;
};

export const ExtendedWarrantyDuration = ({
  readOnly,
  options,
  selectedOption,
  onChange,
}: ExtendedWarrantyDurationProps) => {
  const handleDurationSelect = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(Number(event.target.value));
    },
    [onChange]
  );

  return (
    <select onChange={handleDurationSelect} value={selectedOption} disabled={readOnly}>
      {options.map((option) => (
        <option key={option.duration} value={option.duration}>
          {getDurationLabel(option.duration)}
        </option>
      ))}
    </select>
  );
};
